import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab({ content }) {
  const text = encodeURIComponent("Hello DRC502 Construction, I would like to request a free quote.");
  return (
    <motion.a
      href={`https://wa.me/${content.whatsapp}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 15 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)]"
    >
      <MessageCircle size={26} fill="currentColor" />
    </motion.a>
  );
}
